<template>
  <BaseModal class="post_base_modal">
    <div class="post_base_modal_content">
      <div class="post-wrapper">
        <Post
          :post="post"
          :isModal="isModal"
          style="cursor: default"
          class="post-layer"
          :class="{
            'post-with-comments': commentVisible,
            'post-front': !commentVisible,
          }"
          :commentVisible="commentVisible"
          @toggleComments="commentVisible = !commentVisible"
        />
      </div>

      <transition name="comments-overlay">
        <Comments
          :visible="commentVisible"
          :post="post"
          class="comments-layer"
          @commentVisible="commentVisible = $event"
          @click.stop
          @commentsChanged="onCommentsChanged"
        />
      </transition>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from "@/UI/Modals/BaseModal.vue";
import Post from "./Post.vue";
import Comments from "./Comments.vue";
import { ref, watch } from "vue";

const props = defineProps({
  post: {
    type: Object,
    required: false,
    default: null,
  },
  isModal: {
    type: Boolean,
    default: false,
  },
  commentVisible: {
    type: Boolean,
    default: false,
  },
});

const commentVisible = ref(props?.commentVisible);

watch(
  () => props.commentVisible,
  (val) => {
    commentVisible.value = val;
  },
);

const onCommentsChanged = (delta) => {
  props.post.comments_qty = (props.post.comments_qty || 0) + delta;

  if (delta > 0) {
    props.post.is_comment = true;
  }

  if (props.post.comments_qty <= 0) {
    props.post.is_comment = false;
  }
};
</script>

<style scoped>
.post_base_modal .post {
  margin-bottom: 0 !important;
}

.post_base_modal_content {
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  justify-content: center;
}

.post_base_modal_content::-webkit-scrollbar {
  display: none;
}

.post-wrapper {
  width: calc(95vh * 9 / 15);
  margin: 0 auto;
  position: relative;
  z-index: 6;
}

.post-layer {
  width: 100%;
  height: 100%;
}

.post-with-comments {
  z-index: 5;
}

.post-front {
  transform: translateX(0);
  box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.25);
}

.comments-layer {
  width: calc(95vh * 9 / 15);
  height: 95vh;
  position: relative;
  z-index: 4;
  max-height: 95vh;
  overflow: hidden;
}

.comments-overlay-enter-active {
  transition:
    transform 0.6s cubic-bezier(0.2, 0.8, 0.2, 1),
    opacity 0.2s;
}

.comments-overlay-enter-from {
  transform: translateX(-100%);
}

.comments-overlay-enter-to {
  transform: translateX(0);
}

.comments-overlay-leave-active {
  transition:
    transform 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.25s;
}

.comments-overlay-leave-from {
  transform: translateX(0);
}

.comments-overlay-leave-to {
  transform: translateX(-100%);
}

@media (max-width: 950px) {
  .post_base_modal_content {
    display: block;
    position: relative;
  }

  .post-wrapper {
    width: 100%;
    height: auto;
  }

  .comments-layer {
    width: 100%;
    height: auto;
    aspect-ratio: 9 / 15;
    margin-top: 8px;
    margin-bottom: 15px;
  }

  .comments-overlay-enter-active {
    transition:
      transform 0.6s cubic-bezier(0.2, 0.8, 0.2, 1),
      opacity 0.2s;
  }

  .comments-overlay-enter-from {
    transform: translateY(-100%);
  }

  .comments-overlay-enter-to {
    transform: translateY(0);
  }

  .comments-overlay-leave-active {
    transition:
      transform 0.35s cubic-bezier(0.4, 0, 0.2, 1),
      opacity 0.25s;
  }

  .comments-overlay-leave-from {
    transform: translateY(0);
  }

  .comments-overlay-leave-to {
    transform: translateY(-100%);
  }
}
</style>
